import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import '../styles/CartAddedSuccessModal.css';

const CartAddedSuccessModal = ({ 
    show, 
    onClose, 
    product, 
    quantity, 
    justAdded,
    subtotal, 
    totalItems,
    onContinueShopping,
    onViewCart,
    checkoutUrl
}) => {
    const handleCheckout = useCallback(() => {
        // eslint-disable-next-line no-undef
        window.location.assign(checkoutUrl);
    }, [checkoutUrl]);
    
    return (
        <Modal 
            show={show} 
            onHide={onClose} 
            centered
            dialogClassName={'cart-added--modal'}
            backdrop={'static'}
        >
            <Modal.Header
                closeButton>
                <Modal.Title>
                    Ok, {justAdded} {justAdded === 1 ? 'item was' : 'items were'} added to your cart. What&apos;s next?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    className={'cart-modal--content'}>
                    <div
                        className={'cart-modal--left'}>
                        <h3
                            className={'product--title'}>{product?.title}</h3>
                        <div
                            className={'product--image-container'}>
                            {product?.imageUrl && (
                                <img
                                    src={product.imageUrl}
                                    alt={product.title} 
                                    className={'product--image'}
                                />
                            )}
                        </div>
                        <div
                            className={'product--price'}>
                            {quantity} × ${(product?.price || 0).toFixed(2)}
                        </div>
                    </div>
                    
                    <div
                        className={'cart-modal--right'}>
                        <Button 
                            variant={'primary'} 
                            className={'checkout--button'}
                            onClick={handleCheckout}
                            disabled={!checkoutUrl}
                        >
                            Proceed to checkout
                        </Button>
                        
                        <div
                            className={'order--info'}>
                            <div
                                className={'subtotal'}>
                                <div
                                    className={'subtotal--label'}>Order subtotal</div>
                                <div
                                    className={'subtotal--value'}>${subtotal.toFixed(2)}</div>
                            </div>
                            
                            <div
                                className={'cart--count'}>
                                Your cart contains {totalItems} {totalItems === 1 ? 'item' : 'items'}
                            </div>
                            
                            <div
                                className={'action--buttons'}>
                                <Button 
                                    variant={'primary'} 
                                    className={'continue--button'}
                                    onClick={onContinueShopping}
                                >
                                    Continue Shopping
                                </Button>
                                
                                <Button 
                                    variant={'primary'} 
                                    className={'view--button'}
                                    onClick={onViewCart}
                                >
                                    View or edit your cart
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

CartAddedSuccessModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    product: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        price: PropTypes.number,
        id: PropTypes.number
    }),
    quantity: PropTypes.number,
    justAdded: PropTypes.number,
    subtotal: PropTypes.number,
    totalItems: PropTypes.number,
    onContinueShopping: PropTypes.func.isRequired,
    onViewCart: PropTypes.func.isRequired,
    checkoutUrl: PropTypes.string
};

export default CartAddedSuccessModal; 